<script setup lang="ts">
import { NSelect } from 'naive-ui'
import { useAttrs } from 'vue'

interface SelectOption {
  label: string
  value: any
  disabled?: boolean
  [key: string]: any
}

const props = withDefaults(defineProps<{
  value?: any
  options?: SelectOption[]
  placeholder?: string
  clearable?: boolean
  filterable?: boolean
  multiple?: boolean
  disabled?: boolean
  loading?: boolean
  size?: 'small' | 'medium' | 'large'
  maxTagCount?: number | 'responsive'
  showArrow?: boolean
  remote?: boolean
  consistentMenuWidth?: boolean
  virtualScroll?: boolean
  maxHeight?: number | string
  show?: boolean
  scrollable?: boolean
  checkStrategy?: 'child' | 'all'
  cascade?: boolean
  leafOnly?: boolean
  showPath?: boolean
  separator?: string
  pathSeparator?: string
  expandTrigger?: 'click' | 'hover'
  checkOnClickNode?: boolean
  onLoad?: (node: any) => Promise<SelectOption[]>
}>(), {
  value: undefined,
  options: () => [],
  placeholder: 'Please select',
  clearable: true,
  filterable: false,
  multiple: false,
  disabled: false,
  loading: false,
  size: 'medium',
  maxTagCount: 'responsive',
  showArrow: true,
  remote: false,
  consistentMenuWidth: true,
  virtualScroll: false,
  maxHeight: 300,
  show: undefined,
  scrollable: true,
  checkStrategy: 'child',
  cascade: false,
  leafOnly: false,
  showPath: false,
  separator: ' / ',
  pathSeparator: '/',
  expandTrigger: 'click',
  checkOnClickNode: false,
})

const emit = defineEmits<{
  'update:value': [value: any, option: SelectOption | SelectOption[] | null]
  'update:show': [show: boolean]
  'focus': [e: FocusEvent]
  'blur': [e: FocusEvent]
  'clear': []
  'scroll': [e: Event]
  'search': [value: string]
}>()

const attrs = useAttrs()

const onUpdateValue = (value: any, option: SelectOption | SelectOption[] | null) => {
  emit('update:value', value, option)
}

const onUpdateShow = (show: boolean) => {
  emit('update:show', show)
}

const onFocus = (e: FocusEvent) => {
  emit('focus', e)
}

const onBlur = (e: FocusEvent) => {
  emit('blur', e)
}

const onClear = () => {
  emit('clear')
}

const onScroll = (e: Event) => {
  emit('scroll', e)
}

const onSearch = (value: string) => {
  emit('search', value)
}
</script>

<template>
  <!--  <div class="app-select w-full" :class="[disabled ? 'app-select&#45;&#45;disabled' : '']"> -->
  <NSelect
    :value="value"
    :options="options"
    :placeholder="placeholder"
    :clearable="clearable"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    :loading="loading"
    :size="size"
    :max-tag-count="maxTagCount"
    :show-arrow="showArrow"
    :remote="remote"
    :consistent-menu-width="consistentMenuWidth"
    :virtual-scroll="virtualScroll"
    :max-height="maxHeight"
    :show="show"
    :scrollable="scrollable"
    :check-strategy="checkStrategy"
    :cascade="cascade"
    :leaf-only="leafOnly"
    :show-path="showPath"
    :separator="separator"
    :path-separator="pathSeparator"
    :expand-trigger="expandTrigger"
    :check-on-click-node="checkOnClickNode"
    :on-load="onLoad"
    v-bind="attrs"
    @update:value="onUpdateValue"
    @update:show="onUpdateShow"
    @focus="onFocus"
    @blur="onBlur"
    @clear="onClear"
    @scroll="onScroll"
    @search="onSearch"
  >
    <template #arrow>
      <slot name="arrow" />
    </template>
    <template #empty>
      <slot name="empty" />
    </template>
    <template #action>
      <slot name="action" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
  </NSelect>
<!--  </div> -->
</template>

<style scoped>
/*.app-select--disabled :deep(.n-base-selection) {
  opacity: 1 !important;
}

.app-select--disabled :deep(.n-base-selection-label) {
  opacity: 1 !important;
  font-weight: 500;
  color: #111827 !important;
}

.app-select--disabled :deep(.n-base-selection-input__content) {
  opacity: 1 !important;
  color: #111827 !important;
}

.app-select--disabled :deep(.n-base-selection-placeholder) {
  opacity: 1 !important;
  color: #6B7280 !important;
}*/
</style>
